import styled from 'styled-components';
import { themeGet } from 'styled-system';

const SectionWrapper = styled.section`
  padding: 80px 0;
  overflow: hidden;
  @media (max-width: 990px) {
    padding: 60px 0 30px 0;
  }
  @media (max-width: 767px) {
    padding: 40px 0 30px 0;
  }
  .subtitle {
    max-width: 817px;
    margin-top: 15px;
    margin-left: auto;
    margin-right: auto;
    text-align: left;
  }
`;

export const BoxWrapper = styled.div`
  display: flex;
  justify-content: space-around;
  margin-top: 30px;
  flex-wrap: wrap;
`;

export default SectionWrapper;
